import classNames from 'classnames/bind';
import { SnackbarProvider as NotistackToastProvider } from 'notistack';

import { GlobalStyles, useTheme } from '@mui/material';
import { ToastComponents, ToastIcons } from '@kc-console/common-ui';

import style from './style.module.css';
import { INITIAL_TOAST_AUTO_HIDE_DURATION, type ToastProviderProps } from './types';

import type { SnackbarProviderProps as NotistackToastProviderProps } from 'notistack';

const cx = classNames.bind(style);

const ToastProvider = (props: ToastProviderProps) => {
  const theme = useTheme();
  const {
    classes: classesOriginProps,
    autoHideDuration = INITIAL_TOAST_AUTO_HIDE_DURATION,
    hideIconVariant = false,
    disableWindowBlurListener = true,
    anchorOrigin: anchorOriginProp,
    children,
    Components = ToastComponents,
    iconVariant = ToastIcons,
    ...others
  } = props;

  const anchorOrigin: NotistackToastProviderProps['anchorOrigin'] = {
    vertical: 'bottom',
    horizontal: 'center',
    ...anchorOriginProp,
  };

  return (
    <>
      <GlobalStyles
        styles={{
          ':root': {
            '--kc-console-toast-z-index': theme.zIndex.notification,
          },
        }}
      />
      <NotistackToastProvider
        classes={{
          ...classesOriginProps,
          containerRoot: cx(classesOriginProps?.containerRoot, 'console-ToastContainer'),
          root: cx(classesOriginProps?.root, 'console-Toast'),
        }}
        autoHideDuration={autoHideDuration}
        hideIconVariant={hideIconVariant}
        disableWindowBlurListener={disableWindowBlurListener}
        anchorOrigin={anchorOrigin}
        Components={Components}
        iconVariant={iconVariant}
        {...others}
      >
        {children}
      </NotistackToastProvider>
    </>
  );
};

export default ToastProvider;
